import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy brand-hub leaf → brand workbench drawer (full mode,
// identity tab). See the brand workbench design doc (CommitMind).
export const Route = createFileRoute('/brand/$slug/_brand/identity')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/brand/$slug/home',
      params: { slug: params.slug },
      search: { brand: 'full', brandTab: 'identity' },
    });
  },
});
